import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { MapComponent } from "./components/MapComponent";
import { SafeComponent } from "./components/SafeComponent";
import { FuseboxComponent } from "./components/FuseboxComponent";
import { ModalFuseboxComponent } from "./components/ModalFuseboxComponent";
import { SuspectListComponent } from "./components/SuspectListComponent";
import { UseOwnNameComponent } from "./components/UseOwnNameComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("inventory-items", InventoryComponent);
window.customElements.define("map-component", MapComponent);
window.customElements.define("game-safe", SafeComponent);
window.customElements.define("game-fuse", FuseboxComponent);
window.customElements.define("game-modal-fuse", ModalFuseboxComponent);
window.customElements.define("suspect-list", SuspectListComponent);
window.customElements.define("game-playername", UseOwnNameComponent);
